import React from 'react';
import PropTypes from 'prop-types';
import * as componentStyles from './LogoWall.style.js';

import { connect as connectFela } from 'react-fela';

import deloitte from '../../../../../../images/hp/references/partners/deloitte.svg';
import majales from '../../../../../../images/hp/references/partners/majales.svg';
import mighty from '../../../../../../images/hp/references/partners/mighty.svg';
import iinfo from '../../../../../../images/hp/references/partners/iinfo.svg';
import lfsuh from '../../../../../../images/hp/references/partners/lfsuh.svg';
import devcon from '../../../../../../images/hp/references/partners/devcon.svg';
import colours from '../../../../../../images/hp/references/partners/colours.svg';
import festivalone from '../../../../../../images/hp/references/partners/festivalone.svg';
import designblok from '../../../../../../images/hp/references/partners/designblok.png';
import kviff from '../../../../../../images/hp/references/partners/kviff.png';

const Logo = ({ name, src, width, height, opacity }) => (
    <img key={name} src={src} alt={name} width={width} height={height} style={opacity ? { opacity } : undefined} />
);

const leftColumn = [
    { name: 'Deloitte', src: deloitte },
    { name: 'Letní filmová škola Uherské Hradiště', src: lfsuh },
    { name: 'Colours of Ostrava', src: colours },
];

const middleColumn = [
    { name: 'Majáles', src: majales },
    { name: 'Internet Info', src: iinfo },
    { name: 'KVIFF', src: kviff, width: 108, height: 100, opacity: 0.2 },
    { name: 'Devcon', src: devcon },
];

const rightColumn = [
    { name: 'Mighty Sounds', src: mighty },
    { name: 'Festival One', src: festivalone },
    { name: 'Designblok', src: designblok, width: 114, height: 88, opacity: 0.2 },
];

const LogoWall = ({ styles }) => (
    <div className={styles.wrapper}>
        <div className={styles.column}>
            {leftColumn.map(logo => (
                <Logo {...logo} key={logo.name} />
            ))}
        </div>
        <div className={styles.middleColumn}>
            {middleColumn.map(logo => (
                <Logo {...logo} key={logo.name} />
            ))}
        </div>
        <div className={styles.column}>
            {rightColumn.map(logo => (
                <Logo {...logo} key={logo.name} />
            ))}
        </div>
    </div>
);

LogoWall.propTypes = {
    styles: PropTypes.shape({
        wrapper: PropTypes.string,
        column: PropTypes.string,
        middleColumn: PropTypes.string,
        img: PropTypes.string,
    }),
};

export default connectFela(componentStyles)(LogoWall);
